export default {
	// Config
	apiKey: "AIzaSyB9JDo5bHPlBgtQH_IqLwv5ij0zhjgq5Ls",
  authDomain: "majorny-mytrace.firebaseapp.com",
  projectId: "majorny-mytrace",
  storageBucket: "majorny-mytrace.firebasestorage.app",
  messagingSenderId: "722287095156",
  appId: "1:722287095156:web:495e60661c72b449339021"
};
